import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import LanguageService, { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import GeneralUtils from '../../utilities/GeneralUtils';
import ApiService from '../../service/ApiService';
import { Message } from 'primereact/message';

const CompetitionJobDutyEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition({ ...props?.value, jobDuty: props?.value?.jobDuty !== null ? props?.value?.jobDuty : '' });

    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition ? competition : props?.value,
        validate: (data) => {
            let errors = {};

            if (!data.jobDuty || data.jobDuty.trim() === '') {
                errors.jobDuty = translatedMessage('form.error.job.jobDuty.required');
            } else {
                if (!GeneralUtils.nullIfEmptyHTMLEditor(data.jobDuty) || GeneralUtils.nullIfEmptyHTMLEditor(data.jobDuty).length < 10) {
                    errors.jobDuty = translatedMessage('form.error.job.jobDuty.minLength');
                }
            }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
        competitionService.saveCompetitionJob(_data)
            .then((savedData) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedData, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="workingHours-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const setJobDutyValue = (_jobDuty) => {
        formik.setFieldValue('jobDuty', _jobDuty);
    }

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                header={translatedMessage('job.jobDuty')}
                modal
                className="pcn-dialog"
                contentClassName="pt-0"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="workingHours-form" onSubmit={formik.handleSubmit}>
                    <div className="field pcn-sun-editor w-100 mb-0">                        
                        <div><Message className='mb-1' severity="warn" text={translatedMessage("competition.jobDuty.editor.info1")} /></div>
                        <div><Message className='mb-2' severity="warn" text={translatedMessage("competition.jobDuty.editor.info2")} /></div>
                        <div><label htmlFor="description">{translatedMessage('job.jobDuty')} *</label></div>
                        <SunEditor
                            id="jobDuty" name="jobDuty"
                            lang={LanguageService.getCurrentLanguage()}
                            height="200px"
                            width='auto'
                            defaultValue={formik.values.jobDuty}
                            placeholder={""}
                            setOptions={{
                                buttonList: GeneralUtils.getSunEditorButtons(),
                                font: GeneralUtils.getSunEditorFonts(),
                                defaultStyle: GeneralUtils.getSunEditorDefaultStyle(),
                                charCounter: ApiService.getIsProduction() ? true : false,
                                maxCharCount: ApiService.getIsProduction() ? 10000 : null
                            }}
                            onChange={setJobDutyValue}
                        />
                        {getFormErrorMessage('jobDuty')}
                    </div>


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionJobDutyEditDialog;
